import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actions from '../actions/index';
//image
import {getData, LOGIN, setData, USER_DATA} from "../util/storage";
import {checkIfUserDataAvailable} from "../util/account_management";
import BroadcastList from "../components/BroadcastList";
import {isEmpty, makeUserOnline} from "../util/utility";
import firebase from "../assets/libs/firebase";
import {getMoneyBloxWalletBalance} from "../assets/libs/MoneyBlox";
import {getProfanityWords} from "../util/firebase/firestore";
import HomeContainer from "./content/Home";

class Dashboard extends Component {

    /**
     * @function is invoked immediately after a component is mounted. Initialization that requires DOM nodes should go here.
     * If you need to load data from a remote endpoint, this is a good place to instantiate the network request.
     */
    componentDidMount() {
        //every time the dashboard is loaded we check if the user api_token and token is available
        //it the api_token and token is available we do hit getUserDetails Webservice
        getData(LOGIN)
            .then((data) => {
                if(!isEmpty(data)){
                    this.props.getUserDetails(data.token, data.api_token);
                    this.props.getFollowingList(data.token, data.api_token, "", "")
                }
            })

        this.props.showLeftBar() //show the leftbar
        this.props.showSearchBar() //show the Search bar
        document.getElementsByClassName("modal-overlay")[0].style.display="none";
    }

    /**
     * @function This is invoked when an update is caused by changes to props or state.
     * These methods are called when a component is being re-rendered
     * @param nextProps
     */
    UNSAFE_componentWillReceiveProps(nextProps) {

    }

    render() {

        return (
            <HomeContainer
                match={this.props.match}
                history={this.props.history}
                location={this.props.location}/>
        );
    }
}

function mapStateToProps(state, ownParams) {
    return {
        account_management: state.account_management,
        following: state.following,
        broadcaster_detail_management: state.broadcaster_detail_management
    };
}

export default connect(mapStateToProps, actions)(Dashboard);